import { render, staticRenderFns } from "./Scanner.vue?vue&type=template&id=71064505&scoped=true&"
import script from "./Scanner.vue?vue&type=script&lang=js&"
export * from "./Scanner.vue?vue&type=script&lang=js&"
import style0 from "../../../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=71064505&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71064505",
  null
  
)

export default component.exports